import { render, staticRenderFns } from "./pending-approvals.vue?vue&type=template&id=57a08473&"
import script from "./pending-approvals.vue?vue&type=script&lang=js&"
export * from "./pending-approvals.vue?vue&type=script&lang=js&"
import style0 from "./pending-approvals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pending-approvals.vue"
export default component.exports